"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Reload = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Reload = function Reload() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.3332 9.32866H16.6648C16.2966 9.32866 15.998 9.03027 15.998 8.66205V8.2754C15.9953 8.09463 16.0679 7.92085 16.198 7.79542L18.572 5.42219C16.8379 3.65999 14.4697 2.66594 11.997 2.66231C6.92529 2.67375 2.79042 6.73108 2.68446 11.8003C2.5785 16.8694 6.54021 21.0959 11.607 21.3191C16.6739 21.5424 20.9922 17.6807 21.3327 12.6219C21.3539 12.2695 21.6463 11.9945 21.9995 11.9952H23.3332C23.5151 12.0007 23.6874 12.0772 23.8133 12.2085C23.9358 12.3425 23.9985 12.5207 23.9867 12.7018C23.6555 18.3509 19.4214 23.001 13.8265 23.86C8.23174 24.7192 2.79691 21.554 0.78501 16.2646C-1.22688 10.9754 0.731023 4.99982 5.48326 1.92552C10.2355 -1.14879 16.4903 -0.486153 20.4925 3.51561L22.4796 1.52903C22.6019 1.40218 22.7702 1.33006 22.9464 1.32903H23.3332C23.7015 1.32903 24 1.6275 24 1.99567V8.66205C24 9.03027 23.7015 9.32866 23.3332 9.32866Z",
    clipRule: "evenodd"
  });
};

exports.Reload = Reload;